import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Instagram, Twitter, Facebook, Youtube, Linkedin, MessageCircle } from "lucide-react";

/**
 * Reusable BrandFooter — reads from the central Social Identity registry.
 * Only Active profiles are rendered. The primary handle appears once.
 */
const ICONS = {
    Instagram: Instagram, Threads: MessageCircle, X: Twitter,
    LinkedIn: Linkedin, Facebook: Facebook, YouTube: Youtube,
};

export default function BrandFooter({ platform, dense = false, className = "" }) {
    const [state, setState] = useState({ profiles: [], handle: "@vaultbypd", website: "vaultbypd.com" });
    useEffect(() => {
        api.get("/public/brand/footer", { params: platform ? { platform } : {} })
           .then(r => setState({
               profiles: r.data?.active_profiles || [],
               handle:   r.data?.handle,
               website:  r.data?.website,
           }))
           .catch(() => {});
    }, [platform]);

    const dividerCls = "border-t border-[color:rgba(201,169,107,0.4)]";
    return (
        <div className={`${className}`} data-testid="brand-footer">
            <div className={`${dividerCls} pt-3 flex items-center justify-center gap-4 flex-wrap text-[12px] text-[color:var(--ivory,#F6F3EC)]`}>
                {(state.profiles || []).map(p => {
                    const Icon = ICONS[p.platform];
                    return (
                        <a key={p.platform} href={p.url} target="_blank" rel="noreferrer"
                           className="inline-flex items-center gap-1 hover:opacity-80"
                           data-testid={`brand-footer-link-${p.platform}`}
                           aria-label={p.platform}>
                            {Icon ? <Icon size={13} strokeWidth={1.7} /> : null}
                            {!dense && <span className="text-[11px]">{p.platform}</span>}
                        </a>
                    );
                })}
                <span className="opacity-40 select-none">·</span>
                <span className="font-semibold">{state.handle}</span>
                <span className="opacity-40 select-none">|</span>
                <a href={`https://${state.website}`} target="_blank" rel="noreferrer" className="hover:opacity-80">
                    {state.website}
                </a>
            </div>
        </div>
    );
}
